export default {
  name: 'LayersTwoDashedIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: '#757575'
    }
  }
};